import '../style/helper-line.scss'
import { MIN_COLUMN_WIDTH } from '../config/table'
const overflowClass = 'kye-table-v2__overflow_hidden'

function amendDraggedColumnWidth (store, val, column) {
  try {
    let w = val
    const { fixed, key } = column
    if (fixed) {
      const otherFixedWidthSum = [...(store.states.fixedColumnsOnLeft || []), ...(store.states.fixedColumnsOnRight || [])]
        .filter(i => !(i.children && i.children.length))
        .reduce((sum, col) => {
        return sum += col.key !== key ? col.width : 0
      }, 0)
      const tableOffsetWidth = store.table.$el.offsetWidth
      if (tableOffsetWidth && otherFixedWidthSum + w >= tableOffsetWidth) {
        // 预留最小宽度的2倍
        w = parseInt((tableOffsetWidth - otherFixedWidthSum - 6))
        if (w < MIN_COLUMN_WIDTH) {
          w = MIN_COLUMN_WIDTH
        }
        return w
      } else {
        return w
      }
    } else {
      return w
    }
  } catch (error) {
    return val
  }
}

function verticalHelperLineMouseDown (store, event) {
  const column = store.states.verHelperLine.draggingColumn
  if (!column || column.resizable === false) { return }
  const heplerLineNodeAnchor = store.table.$refs.heplerLineAnchor
  const targetNode = store.table.$el.querySelector(`[data-helpline-key='${column.tableType + column.key}']`)
  if (!targetNode) {
    return
  }
  const handelAnchoreMouseupEvent = (val) => {
    try {
      // 判断列的宽度的限制
      const width = amendDraggedColumnWidth(store, val, column)
      store.table.$emit('header-dragend', width, column.width, column, event)
      // 同时需要修改 visibleFlatColumns的width
      store.updateVisibleFlatColumnsCol(column.key, {
        width,
        _isAutoWidth: false // 自动计算的宽度变成固定
      })
      store.updateColumns()
      store.setHelperDraggingStatus(true)
      if (store.table && store.table.$el && store.table.$el.classList.contains(overflowClass)) {
        store.table.$el.classList.remove(overflowClass)
      }
      setTimeout(() => {
        store.setHelperDraggingStatus(false)
      }, 0)
    } catch (error) {
      console.log(error)
    }
  }
  const params = {
    target: column,
    targetNode,
    targetContainerNode: store.table.$el,
    heplerLineNode: store.table.$refs.heplerLine,
    heplerLineNodeAnchor,
    handleMouseMove: () => {
      if (store.table && store.table.$el && !store.table.$el.classList.contains(overflowClass)) {
        store.table.$el.classList.add(overflowClass)
      }
    }
  }
  store.states.verHelperLine.setHelperLineStatus(event, params, handelAnchoreMouseupEvent)
}

function verticalHelperLineMouseMout (store) {
  store.states.verHelperLine.visibleHeplerLineNodeAnchor()
}

export function createHelperLine () {
  return {
    functional: true,
    render (h, context) {
      const className = context.props.direction === 'vertical' ? 'is-vertical-line' : 'is-horizontal-line'
      const createAnchor = () => {
        const handleMouseDown = (event) => {
          verticalHelperLineMouseDown(context.props.store, event)
        }
        const handleMouseout = () => {
          verticalHelperLineMouseMout(context.props.store)
        }
        const attrs = {
          style: {
            display: 'none'
          },
          on: {
            mousedown: handleMouseDown,
            mouseout: handleMouseout
          },
          ref: 'heplerLineAnchor',
          class: 'kye-hepler-line-anchor'
        }
        return <div {...attrs}></div>
      }
      const anchor = createAnchor()
      return <div class='kye-hepler-line-wrap'>
        <div
          style="display:none"
          class={['kye-hepler-line', className]}
          ref="heplerLine"
        >
        </div>
        {
          anchor
        }
      </div>
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/helper-line.js